// countrySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Countries } from 'model/countries-model';

interface CountryState {
  countries: Countries[];
}

const initialState: CountryState = {
  countries: [],
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountries: (state, action: PayloadAction<Countries[]>) => {
      state.countries = action.payload;
    },
  },
});

export const { setCountries } = countrySlice.actions;
export const selectCountries = (state: { country: CountryState }) => state.country?.countries;

export default countrySlice.reducer;
